<template>
  <div class="paypal_area">
    <div id="paypal-button-container">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PayPalButton',
  components: {
  },
  data: () => ({
    payMethod: '',
  }),
  props: {
    amount: {
      type: String || Number || Object || Array || Boolean || Function || Symbol,
    },
  },
  async mounted() {
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.VUE_APP_PAYPAL_CLIENT_ID}&disable-funding=card&locale=en_US&currency=JPY`;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });

    // PayPalのSDKが読み込まれた後に実行する処理をここに記述
    this.setupPayPalButtons();
  },
  methods: {
    setupPayPalButtons() {
      window.paypal.Buttons({
        commit: false, // クレジットカードの支払いボタンを非表示にする
        createOrder: (data, actions) => actions.order.create({
          purchase_units: [{
            amount: {
              currency_code: 'JPY',
              value: this.amount,
            },
          }],
          application_context: {
            shipping_preference: 'NO_SHIPPING',
          },
        }),
        onApprove: (data, actions) => actions.order.capture().then((details) => {
          const modifiedDetails = {
            ...details,
            pay_id: 3,
          };
          this.$emit('payPalOnApprove', modifiedDetails);
        }),
        onError: () => {
          alert('An error has occurred');
        },
      }).render('#paypal-button-container');
    },
  },
};
</script>

<style lang="scss" scoped>
#paypal-button-container {
  margin: 10px auto 0;
}
</style>
